import { fabric } from 'fabric';
import { readPsd } from 'ag-psd';

var AcProductionStudio = (function() {
  var DOC_W = 1700;
  var DOC_H = 2200;
  var VIEW_SCALE = 0.3;
  var PRINT_AREA = { left: 510, top: 470, width: 680, height: 900 };
  // Exact Photoshop guides stored in the supplied 201 PSD (PSD guide units
  // are 1/32 pixel). Shirt center is based on the visible garment bounds.
  var TEMPLATE_GUIDES = { vertical: [96.53, 531.09, 1150.56], horizontal: [601.69] };
  var SHIRT_CENTER = { x: 850, y: 1062 };

  function init() {
    initArtworkPreview();
    initColorPicker();
    initDesignForms();
    initSubmissionQueue();
    document.querySelectorAll('[data-ac-production-editor]').forEach(initEditor);
    var generateAllButton = document.querySelector('.js-ac-generate-all');
    if (generateAllButton) {
      generateAllButton.addEventListener('click', function() { generateAll(generateAllButton); });
    }
  }

  function initSubmissionQueue() {
    document.querySelectorAll('.js-copy-ac-sku').forEach(function(button) {
      button.addEventListener('click', function() {
        var sku = button.getAttribute('data-sku');
        if (!sku) return;
        var copied = function() {
          var original = button.textContent;
          button.textContent = 'Copied';
          window.setTimeout(function() { button.textContent = original; }, 1400);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(sku).then(copied);
        } else {
          var input = document.createElement('textarea');
          input.value = sku; input.style.position = 'fixed'; input.style.opacity = '0';
          document.body.appendChild(input); input.select(); document.execCommand('copy'); input.remove(); copied();
        }
      });
    });
  }

  function initColorPicker() {
    document.addEventListener('click', function(event) {
      var selectAll = event.target.closest && event.target.closest('.js-ac-select-all');
      var clearAll = event.target.closest && event.target.closest('.js-ac-clear-all');
      var button = selectAll || clearAll;
      if (!button) return;
      var picker = button.closest('[data-ac-color-picker]');
      if (!picker) return;
      picker.querySelectorAll('input[type="checkbox"]').forEach(function(checkbox) {
        checkbox.checked = !!selectAll;
      });
    });
  }

  function initDesignForms() {
    var list = document.querySelector('.js-ac-design-list');
    if (!list) return;
    var add = document.querySelector('.js-ac-add-design');
    if (add) {
      add.addEventListener('click', function() {
        var cards = list.querySelectorAll('.js-ac-design');
        var clone = cards[cards.length - 1].cloneNode(true);
        clone.querySelectorAll('input[type="text"]').forEach(function(input) { input.value = ''; });
        clone.querySelectorAll('input[type="file"]').forEach(function(input) { input.value = ''; });
        var preview = clone.querySelector('.js-ac-artwork-preview');
        if (preview) {
          preview.hidden = true;
          preview.removeAttribute('src');
        }
        var drop = clone.querySelector('.ac-studio-upload');
        if (drop) drop.classList.remove('has-preview');
        var note = clone.querySelector('.js-ac-artwork-note');
        if (note) note.parentNode.removeChild(note);
        list.appendChild(clone);
        reindexDesigns(list);
      });
    }
    list.addEventListener('click', function(event) {
      var remove = event.target.closest && event.target.closest('.js-ac-remove-design');
      if (!remove) return;
      if (list.querySelectorAll('.js-ac-design').length < 2) return;
      var card = remove.closest('.js-ac-design');
      if (card) card.parentNode.removeChild(card);
      reindexDesigns(list);
    });
    reindexDesigns(list);
  }

  function reindexDesigns(list) {
    var cards = list.querySelectorAll('.js-ac-design');
    cards.forEach(function(card, index) {
      card.querySelectorAll('[name]').forEach(function(field) {
        field.name = field.name.replace(/designs\[\d+\]/, 'designs[' + index + ']');
      });
      var title = card.querySelector('.js-ac-design-number');
      if (title) title.textContent = 'Design ' + (index + 1);
      var remove = card.querySelector('.js-ac-remove-design');
      if (remove) remove.hidden = cards.length < 2;
    });
  }

  function initArtworkPreview() {
    document.addEventListener('change', function(event) {
      var input = event.target;
      if (!input.classList || !input.classList.contains('js-ac-artwork')) return;
      var file = input.files && input.files[0];
      var drop = input.closest('.ac-studio-upload');
      var preview = drop && drop.querySelector('.js-ac-artwork-preview');
      if (!file || !preview) return;
      setArtworkNote(drop, 'Reading ' + file.name + '…', false);
      preview.onload = null;
      preview.onerror = null;
      preview.hidden = true;
      preview.removeAttribute('src');
      drop.classList.remove('has-preview');
      var requestId = (input.acPreviewRequest || 0) + 1;
      input.acPreviewRequest = requestId;
      file.arrayBuffer().then(function(buffer) {
        return new Promise(function(resolve) { setTimeout(function() { resolve(buffer); }, 30); });
      }).then(function(buffer) {
        if (input.acPreviewRequest !== requestId) return null;
        return artworkPreviewCanvas(buffer);
      }).then(function(source) {
        if (!source || input.acPreviewRequest !== requestId) return;
        preview.onload = function() {
          if (input.acPreviewRequest !== requestId) return;
          if (preview.naturalWidth < 2 || preview.naturalHeight < 2) {
            showArtworkPreviewFailure(drop, preview, file);
            return;
          }
          preview.hidden = false;
          drop.classList.add('has-preview');
          setArtworkNote(drop, file.name, false);
        };
        preview.onerror = function() {
          if (input.acPreviewRequest !== requestId) return;
          showArtworkPreviewFailure(drop, preview, file);
        };
        preview.src = source.toDataURL('image/png');
      }).catch(function() {
        if (input.acPreviewRequest !== requestId) return;
        showArtworkPreviewFailure(drop, preview, file);
      });
    });
  }

  function showArtworkPreviewFailure(drop, preview, file) {
    preview.hidden = true;
    preview.removeAttribute('src');
    drop.classList.remove('has-preview');
    setArtworkNote(drop, file.name + ' is selected. A preview could not be shown, and it will still upload with the batch.', true);
  }

  function setArtworkNote(drop, message, isError) {
    var note = drop.nextElementSibling;
    if (!note || !note.classList || !note.classList.contains('js-ac-artwork-note')) note = null;
    if (!message) {
      if (note) note.parentNode.removeChild(note);
      return;
    }
    if (!note) {
      note = document.createElement('p');
      note.className = 'js-ac-artwork-note';
      if (drop.nextSibling) drop.parentNode.insertBefore(note, drop.nextSibling);
      else drop.parentNode.appendChild(note);
    }
    note.className = isError ? 'js-ac-artwork-note is-error' : 'js-ac-artwork-note';
    note.textContent = message;
  }

  function scaledPreview(source) {
    var width = source.width || source.naturalWidth || 0;
    var height = source.height || source.naturalHeight || 0;
    if (!width || !height) return null;
    var scale = Math.min(1, 480 / Math.max(width, height));
    var canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(width * scale));
    canvas.height = Math.max(1, Math.round(height * scale));
    canvas.getContext('2d').drawImage(source, 0, 0, canvas.width, canvas.height);
    return canvasHasPixels(canvas) ? canvas : null;
  }

  function canvasHasPixels(canvas) {
    var context = canvas.getContext('2d');
    var pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
    var stepX = Math.max(1, Math.floor(canvas.width / 24));
    var stepY = Math.max(1, Math.floor(canvas.height / 24));
    var y;
    var x;
    for (y = 0; y < canvas.height; y += stepY) {
      for (x = 0; x < canvas.width; x += stepX) {
        if (pixels[(y * canvas.width + x) * 4 + 3] > 10) return true;
      }
    }
    return false;
  }

  function loadPsdThumbnail(buffer) {
    return new Promise(function(resolve) {
      var raw;
      try {
        var psd = readPsd(buffer, { skipLayerImageData: true, skipCompositeImageData: true, useRawThumbnail: true });
        raw = psd.imageResources && psd.imageResources.thumbnailRaw;
      } catch (error) {
        resolve(null);
        return;
      }
      if (!raw || !raw.data || !raw.data.byteLength) {
        resolve(null);
        return;
      }
      var url = URL.createObjectURL(new Blob([raw.data], { type: 'image/jpeg' }));
      var image = new Image();
      image.onload = function() {
        URL.revokeObjectURL(url);
        resolve(scaledPreview(image));
      };
      image.onerror = function() {
        URL.revokeObjectURL(url);
        resolve(null);
      };
      image.src = url;
    });
  }

  function fallbackPreviewCanvas(buffer) {
    try {
      var composite = readPsd(buffer, { skipLayerImageData: true, skipThumbnail: true });
      return composite.canvas && scaledPreview(composite.canvas);
    } catch (error) {
      return null;
    }
  }

  function artworkPreviewCanvas(buffer) {
    var isolated = null;
    try { isolated = scaledPreview(readArtworkPsd(buffer).image); } catch (error) {}
    if (isolated) return Promise.resolve(isolated);
    return loadPsdThumbnail(buffer).then(function(thumbnail) {
      if (thumbnail) return thumbnail;
      var fallback = fallbackPreviewCanvas(buffer);
      if (fallback) return fallback;
      throw new Error('no preview');
    });
  }

  function findNamedArtworkLayer(layers) {
    var found = null;
    (layers || []).some(function(layer) {
      if (layer.name && layer.name.trim().toLowerCase() === 'artwork') found = layer;
      if (!found && layer.children) found = findNamedArtworkLayer(layer.children);
      return !!found;
    });
    return found;
  }

  function backgroundLayerName(name) {
    return /^(background|background copy|bg|backdrop|color fill|solid color)(\s+\d+)?$/i.test((name || '').trim());
  }

  function canvasLooksLikeSolidFill(canvas) {
    if (!canvas || !canvas.width || !canvas.height) return true;
    var context = canvas.getContext('2d');
    var pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
    var stepX = Math.max(1, Math.floor(canvas.width / 40));
    var stepY = Math.max(1, Math.floor(canvas.height / 40));
    var first = null; var compared = 0; var similar = 0; var opaque = 0; var sampled = 0;
    for (var y = 0; y < canvas.height; y += stepY) {
      for (var x = 0; x < canvas.width; x += stepX) {
        sampled += 1;
        var offset = (y * canvas.width + x) * 4;
        if (pixels[offset + 3] < 245) continue;
        opaque += 1;
        if (!first) first = [pixels[offset], pixels[offset + 1], pixels[offset + 2]];
        compared += 1;
        if (Math.abs(pixels[offset] - first[0]) < 4 &&
            Math.abs(pixels[offset + 1] - first[1]) < 4 &&
            Math.abs(pixels[offset + 2] - first[2]) < 4) similar += 1;
      }
    }
    return compared > 20 && opaque / sampled > 0.985 && similar / compared > 0.985;
  }

  function artworkCandidates(layers, hiddenParent, candidates) {
    (layers || []).forEach(function(layer) {
      var hidden = hiddenParent || layer.hidden;
      if (hidden) return;
      if (layer.children) artworkCandidates(layer.children, hidden, candidates);
      if (!layer.canvas || backgroundLayerName(layer.name) || canvasLooksLikeSolidFill(layer.canvas)) return;
      var score = 0;
      if (layer.placedLayer) score += 100;
      if (/^(art|artwork|design|graphic|print)/i.test((layer.name || '').trim())) score += 50;
      if (!/^layer(\s+\d+)?$/i.test((layer.name || '').trim())) score += 10;
      candidates.push({ layer: layer, score: score });
    });
  }

  function findFirstVisibleArtworkLayer(layers) {
    var candidates = [];
    artworkCandidates(layers, false, candidates);
    candidates.sort(function(left, right) { return right.score - left.score; });
    return candidates.length ? candidates[0].layer : null;
  }

  function drawLayerTree(context, layer) {
    if (layer.hidden || backgroundLayerName(layer.name)) return;
    if (layer.children && layer.children.length) {
      layer.children.slice().reverse().forEach(function(child) { drawLayerTree(context, child); });
      return;
    }
    if (!layer.canvas || canvasLooksLikeSolidFill(layer.canvas)) return;
    context.drawImage(layer.canvas, layer.left || 0, layer.top || 0);
  }

  function cropTransparentCanvas(canvas, emptyMessage) {
    var context = canvas.getContext('2d');
    var pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
    var left = canvas.width; var top = canvas.height; var right = -1; var bottom = -1;
    for (var y = 0; y < canvas.height; y += 1) {
      for (var x = 0; x < canvas.width; x += 1) {
        if (pixels[(y * canvas.width + x) * 4 + 3] > 2) {
          left = Math.min(left, x); top = Math.min(top, y); right = Math.max(right, x); bottom = Math.max(bottom, y);
        }
      }
    }
    if (right < left || bottom < top) throw new Error(emptyMessage || 'ARTWORK is empty');
    var cropped = document.createElement('canvas');
    cropped.width = right - left + 1; cropped.height = bottom - top + 1;
    cropped.getContext('2d').drawImage(canvas, left, top, cropped.width, cropped.height, 0, 0, cropped.width, cropped.height);
    return cropped;
  }

  function renderArtworkNode(psd, layer) {
    var canvas = document.createElement('canvas');
    if (layer.canvas && !layer.children) {
      canvas.width = layer.canvas.width;
      canvas.height = layer.canvas.height;
      canvas.getContext('2d').drawImage(layer.canvas, 0, 0);
    } else {
      canvas.width = psd.width;
      canvas.height = psd.height;
      drawLayerTree(canvas.getContext('2d'), layer);
    }
    removeEdgeBackground(canvas);
    return cropTransparentCanvas(canvas);
  }

  function removeEdgeBackground(canvas) {
    var width = canvas.width;
    var height = canvas.height;
    if (width < 2 || height < 2) return;
    var context = canvas.getContext('2d');
    var image = context.getImageData(0, 0, width, height);
    var pixels = image.data;
    var seeds = [[0, 0], [width - 1, 0], [0, height - 1], [width - 1, height - 1]];
    var opaque = [];
    seeds.forEach(function(seed) {
      var offset = (seed[1] * width + seed[0]) * 4;
      if (pixels[offset + 3] < 245) return;
      opaque.push([pixels[offset], pixels[offset + 1], pixels[offset + 2], seed[0], seed[1]]);
    });
    if (opaque.length < 2) return;
    var reference = opaque[0];
    var matches = opaque.filter(function(color) {
      return Math.abs(color[0] - reference[0]) < 12 &&
        Math.abs(color[1] - reference[1]) < 12 &&
        Math.abs(color[2] - reference[2]) < 12;
    });
    if (matches.length < 2) return;
    var tolerance = 32;
    var visited = new Uint8Array(width * height);
    var stack = [];
    matches.forEach(function(color) { stack.push(color[3], color[4]); });
    while (stack.length) {
      var y = stack.pop();
      var x = stack.pop();
      if (x < 0 || y < 0 || x >= width || y >= height) continue;
      var index = y * width + x;
      if (visited[index]) continue;
      visited[index] = 1;
      var offset = index * 4;
      if (pixels[offset + 3] < 10) continue;
      if (Math.abs(pixels[offset] - reference[0]) > tolerance ||
          Math.abs(pixels[offset + 1] - reference[1]) > tolerance ||
          Math.abs(pixels[offset + 2] - reference[2]) > tolerance) continue;
      pixels[offset + 3] = 0;
      stack.push(x - 1, y, x + 1, y, x, y - 1, x, y + 1);
    }
    context.putImageData(image, 0, 0);
  }

  function readArtworkPsd(buffer, requireNamedArtwork) {
    var psd = readPsd(buffer, { skipThumbnail: true });
    var layer = findNamedArtworkLayer(psd.children);
    if (!layer && !requireNamedArtwork) layer = findFirstVisibleArtworkLayer(psd.children);
    if (!layer) throw new Error('ARTWORK layer or group not found');
    return { image: renderArtworkNode(psd, layer), namedArtwork: !!findNamedArtworkLayer(psd.children) };
  }

  function loadSourceArtwork(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function(response) {
      if (!response.ok) throw new Error('Artwork source could not be loaded');
      return response.blob();
    }).then(function(blob) {
      return blob.arrayBuffer().then(function(buffer) {
        if (String.fromCharCode.apply(null, new Uint8Array(buffer.slice(0, 4))) === '8BPS') {
          var source = readArtworkPsd(buffer);
          source.psdBlob = blob;
          return source;
        }
        return loadImage(URL.createObjectURL(blob)).then(function(image) { return { image: image, psdBlob: null }; });
      });
    });
  }

  function loadImage(url) {
    return new Promise(function(resolve, reject) {
      var image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = function() { resolve(image); };
      image.onerror = reject;
      image.src = url;
    });
  }

  function initEditor(root) {
    var generateButton = root.querySelector('.js-ac-generate');
    if (generateButton) {
      generateButton.addEventListener('click', function() {
        if (!root.acStudioState) {
          window.alert(root.acStudioError || 'The artwork is still loading. Wait for the preview, then generate.');
          return;
        }
        generate(root.acStudioState);
      });
    }

    var canvasElement = root.querySelector('canvas');
    var canvas = new fabric.Canvas(canvasElement, {
      preserveObjectStacking: true,
      selection: false,
      backgroundColor: '#fff',
    });
    canvas.setWidth(DOC_W * VIEW_SCALE);
    canvas.setHeight(DOC_H * VIEW_SCALE);

    var variants = JSON.parse(root.querySelector('.js-ac-variants-data').textContent);
    Promise.all([
      loadImage(variants[0].base_url),
      loadSourceArtwork(root.dataset.artworkUrl),
      loadImage(root.dataset.overlayUrl),
      loadImage(root.dataset.logoUrl),
      loadImage(root.dataset.neckPrintUrl),
      loadImage(root.dataset.shirtMaskUrl),
    ]).then(function(images) {
      var state = {
        root: root,
        canvas: canvas,
        baseImage: images[0],
        artworkImage: images[1].image,
        sourcePsdBlob: images[1].psdBlob,
        overlayImage: images[2],
        logoImage: images[3],
        neckPrintImage: images[4],
        shirtMaskImage: images[5],
        widthInches: parseFloat(root.dataset.widthInches),
        placementX: parseFloat(root.dataset.placementX),
        placementY: parseFloat(root.dataset.placementY),
        rotation: parseFloat(root.dataset.rotation),
        variants: variants,
        activeVariant: variants[0],
        guidesVisible: true,
      };
      buildCanvas(state);
      bindControls(state);
      bindNeckPrintControls(state);
      root.acStudioState = state;
      canvasBlob(state.artworkImage, 'image/png').then(function(blob) {
        state.sourceArtworkBlob = blob;
      }).catch(function() {
        state.sourceArtworkBlob = null;
      });
    }).catch(function() {
      root.acStudioError = 'The product preview could not be loaded. Reload the page and try again.';
      root.querySelector('.ac-placement-canvas-stage').innerHTML = '<div class="alert-box alert">The product preview could not be loaded.</div>';
    });
  }

  function buildCanvas(state) {
    var base = new fabric.Image(state.baseImage, {
      left: 0, top: 0, scaleX: VIEW_SCALE, scaleY: VIEW_SCALE,
      selectable: false, evented: false,
    });
    var artWidth = state.widthInches / 13 * PRINT_AREA.width * VIEW_SCALE;
    var art = new fabric.Image(state.artworkImage, {
      left: (PRINT_AREA.left + state.placementX * PRINT_AREA.width) * VIEW_SCALE,
      top: (PRINT_AREA.top + state.placementY * PRINT_AREA.height) * VIEW_SCALE,
      originX: 'center', originY: 'center', angle: state.rotation,
      cornerColor: '#e94d35', cornerStyle: 'circle', transparentCorners: false,
      borderColor: '#e94d35', borderDashArray: [6, 4],
      lockUniScaling: true, lockRotation: true,
      hasRotatingPoint: false,
    });
    art.scaleToWidth(artWidth);
    art.setControlsVisibility({ mt: false, mb: false, ml: false, mr: false, mtr: false });

    var overlay = new fabric.Image(state.overlayImage, {
      left: 0, top: 0, scaleX: VIEW_SCALE, scaleY: VIEW_SCALE,
      selectable: false, evented: false,
    });
    var neckPrint = new fabric.Image(state.neckPrintImage, {
      left: 0, top: 0, scaleX: VIEW_SCALE, scaleY: VIEW_SCALE,
      selectable: false, evented: false, globalCompositeOperation: 'screen',
      visible: resolvedNeckPrint(state.activeVariant) === 'white',
    });
    var guides = buildGuides();
    state.canvas.add(base, neckPrint, art, overlay);
    guides.forEach(function(guide) { state.canvas.add(guide); });
    state.base = base;
    state.neckPrint = neckPrint;
    state.guides = guides;
    state.art = art;
    state.canvas.setActiveObject(art);
    state.canvas.requestRenderAll();

    art.on('moving', function() { syncStateFromArtwork(state); });
    art.on('scaling', function() { syncStateFromArtwork(state); });
    art.on('modified', function() { syncStateFromArtwork(state); savePlacement(state); });
  }

  function buildGuides() {
    var color = '#20c7cf';
    var common = { stroke: color, strokeWidth: 1, opacity: 0.85, selectable: false, evented: false };
    var guides = [];
    TEMPLATE_GUIDES.vertical.forEach(function(x) {
      guides.push(new fabric.Line([x * VIEW_SCALE, 0, x * VIEW_SCALE, DOC_H * VIEW_SCALE], common));
    });
    TEMPLATE_GUIDES.horizontal.forEach(function(y) {
      guides.push(new fabric.Line([0, y * VIEW_SCALE, DOC_W * VIEW_SCALE, y * VIEW_SCALE], common));
    });
    guides.push(new fabric.Line(
      [SHIRT_CENTER.x * VIEW_SCALE, 0, SHIRT_CENTER.x * VIEW_SCALE, DOC_H * VIEW_SCALE],
      Object.assign({}, common, { strokeDashArray: [5, 4], opacity: 0.65 })
    ));
    guides.push(new fabric.Line(
      [0, SHIRT_CENTER.y * VIEW_SCALE, DOC_W * VIEW_SCALE, SHIRT_CENTER.y * VIEW_SCALE],
      Object.assign({}, common, { strokeDashArray: [5, 4], opacity: 0.65 })
    ));
    return guides;
  }

  function bindControls(state) {
    var width = state.root.querySelector('.js-ac-width');
    var previewColor = state.root.querySelector('.js-ac-preview-color');
    previewColor.addEventListener('change', function() {
      var variant = state.variants[parseInt(previewColor.value, 10)];
      loadImage(variant.base_url).then(function(image) {
        state.activeVariant = variant;
        state.baseImage = image;
        state.base.setElement(image);
        state.base.set({ scaleX: VIEW_SCALE, scaleY: VIEW_SCALE });
        updateNeckPrintPreview(state);
        updateFilePlan(state, variant);
        state.canvas.requestRenderAll();
      });
    });
    width.addEventListener('input', function() {
      state.widthInches = parseFloat(width.value);
      state.art.scaleToWidth(state.widthInches / 13 * PRINT_AREA.width * VIEW_SCALE);
      state.art.setCoords();
      state.root.querySelector('.ac-width-control output').textContent = state.widthInches.toFixed(1) + '″';
      state.canvas.requestRenderAll();
    });
    width.addEventListener('change', function() { syncStateFromArtwork(state); savePlacement(state); });

    state.root.querySelector('.js-ac-center').addEventListener('click', function() {
      state.placementX = 0.5;
      state.art.set({ left: (PRINT_AREA.left + PRINT_AREA.width / 2) * VIEW_SCALE });
      state.art.setCoords(); state.canvas.requestRenderAll(); savePlacement(state);
    });
    state.root.querySelector('.js-ac-reset').addEventListener('click', function() {
      state.widthInches = 10.5; state.placementX = 0.5; state.placementY = 0.39;
      width.value = state.widthInches;
      state.root.querySelector('.ac-width-control output').textContent = '10.5″';
      state.art.scaleToWidth(state.widthInches / 13 * PRINT_AREA.width * VIEW_SCALE);
      state.art.set({
        left: (PRINT_AREA.left + state.placementX * PRINT_AREA.width) * VIEW_SCALE,
        top: (PRINT_AREA.top + state.placementY * PRINT_AREA.height) * VIEW_SCALE,
      });
      state.art.setCoords(); state.canvas.requestRenderAll(); savePlacement(state);
    });
    state.root.querySelector('.js-ac-guides').addEventListener('click', function(event) {
      state.guidesVisible = !state.guidesVisible;
      state.guides.forEach(function(guide) { guide.visible = state.guidesVisible; });
      event.currentTarget.textContent = state.guidesVisible ? 'Hide guides' : 'Show guides';
      state.canvas.requestRenderAll();
    });
  }

  function bindNeckPrintControls(state) {
    state.root.querySelectorAll('.js-ac-neck-print').forEach(function(select) {
      select.addEventListener('change', function() {
        var variant = state.variants.filter(function(item) { return String(item.id) === select.dataset.variantId; })[0];
        if (!variant) return;
        variant.neck_print = select.value;
        if (select.value !== 'auto') variant.resolved_neck_print = select.value;
        if (state.activeVariant.id === variant.id) updateNeckPrintPreview(state);
        fetch(variant.position_url, {
          method: 'PATCH', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken(), 'Accept': 'application/json' },
          body: JSON.stringify({ ac_production_variant: { neck_print: select.value } }),
        }).then(function(response) {
          if (!response.ok) throw new Error('save failed');
          return response.json();
        }).then(function(result) {
          variant.resolved_neck_print = result.variant.resolved_neck_print;
          variant.neck_print_blend_mode = result.variant.neck_print_blend_mode;
          if (state.activeVariant.id === variant.id) updateNeckPrintPreview(state);
        }).catch(function() { window.alert('The neck-tag choice could not be saved.'); });
      });
    });
  }

  function resolvedNeckPrint(variant) {
    return variant.neck_print === 'auto' ? variant.resolved_neck_print : variant.neck_print;
  }

  function updateNeckPrintPreview(state) {
    state.neckPrint.visible = resolvedNeckPrint(state.activeVariant) === 'white';
    state.canvas.requestRenderAll();
  }

  function updateFilePlan(state, variant) {
    state.root.querySelector('.js-ac-presentation-name').textContent = variant.presentation_basename + '.jpg';
    state.root.querySelector('.js-ac-website-name').textContent = variant.website_basename + '.png';
    state.root.querySelector('.js-ac-psd-name').textContent = variant.package_folder_name + '.psd';
    var psdLink = state.root.querySelector('.js-ac-download-psd');
    if (psdLink) psdLink.href = variant.download_psd_url;
  }

  function syncStateFromArtwork(state) {
    state.widthInches = state.art.getScaledWidth() / VIEW_SCALE / PRINT_AREA.width * 13;
    state.placementX = ((state.art.left / VIEW_SCALE) - PRINT_AREA.left) / PRINT_AREA.width;
    state.placementY = ((state.art.top / VIEW_SCALE) - PRINT_AREA.top) / PRINT_AREA.height;
    state.placementX = Math.max(0, Math.min(1, state.placementX));
    state.placementY = Math.max(0, Math.min(1, state.placementY));
    var width = state.root.querySelector('.js-ac-width');
    width.value = state.widthInches.toFixed(1);
    state.root.querySelector('.ac-width-control output').textContent = state.widthInches.toFixed(1) + '″';
  }

  function csrfToken() {
    var tag = document.querySelector('meta[name="csrf-token"]');
    return tag ? tag.content : '';
  }

  function savePlacement(state) {
    var status = state.root.querySelector('.js-ac-save-status');
    status.textContent = 'Saving placement…';
    fetch(state.root.dataset.positionUrl, {
      method: 'PATCH', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken(), 'Accept': 'application/json' },
      body: JSON.stringify({ ac_production_variant: {
        artwork_width_inches: state.widthInches.toFixed(2),
        placement_x: state.placementX.toFixed(5), placement_y: state.placementY.toFixed(5), rotation: 0,
      } }),
    }).then(function(response) {
      if (!response.ok) throw new Error('save failed');
      status.textContent = 'Placement saved.';
    }).catch(function() { status.textContent = 'Placement could not be saved.'; });
  }

  function drawArtwork(context, state, scaleX, scaleY) {
    var width = state.widthInches / 13 * PRINT_AREA.width * scaleX;
    var sourceWidth = state.artworkImage.naturalWidth || state.artworkImage.width;
    var sourceHeight = state.artworkImage.naturalHeight || state.artworkImage.height;
    var height = width * sourceHeight / sourceWidth;
    var x = (PRINT_AREA.left + state.placementX * PRINT_AREA.width) * scaleX;
    var y = (PRINT_AREA.top + state.placementY * PRINT_AREA.height) * scaleY;
    context.save(); context.translate(x, y); context.rotate(state.rotation * Math.PI / 180);
    context.drawImage(state.artworkImage, -width / 2, -height / 2, width, height); context.restore();
  }

  function renderPresentation(state, variant, baseImage) {
    var canvas = document.createElement('canvas'); canvas.width = DOC_W; canvas.height = DOC_H;
    var ctx = canvas.getContext('2d'); ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, DOC_W, DOC_H);
    ctx.drawImage(baseImage, 0, 0, DOC_W, DOC_H); drawNeckPrint(ctx, state, variant); drawArtwork(ctx, state, 1, 1);
    ctx.drawImage(state.overlayImage, 0, 0, DOC_W, DOC_H);
    ctx.fillStyle = '#30343b'; ctx.font = '700 54px Arial'; ctx.fillText(state.root.dataset.designCode + '-' + state.root.dataset.blankCode, 78, 120);
    ctx.fillStyle = '#b8bbc0'; ctx.font = '700 45px Arial'; ctx.fillText(state.root.dataset.designName.toUpperCase(), 78, 175);
    ctx.fillStyle = '#30343b'; ctx.font = '700 48px Arial'; ctx.fillText(variant.color_name.toUpperCase(), 78, 235);
    var logoWidth = 410; var logoHeight = logoWidth * state.logoImage.naturalHeight / state.logoImage.naturalWidth;
    ctx.drawImage(state.logoImage, DOC_W - logoWidth - 70, DOC_H - logoHeight - 55, logoWidth, logoHeight);
    return canvas;
  }

  function renderWebsite(state, variant, baseImage) {
    var canvas = document.createElement('canvas'); canvas.width = DOC_W; canvas.height = DOC_H;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(baseImage, 0, 0, DOC_W, DOC_H);
    drawNeckPrint(ctx, state, variant);
    drawArtwork(ctx, state, 1, 1);
    ctx.drawImage(state.overlayImage, 0, 0, DOC_W, DOC_H);
    ctx.globalCompositeOperation = 'destination-in';
    ctx.drawImage(state.shirtMaskImage, 0, 0, DOC_W, DOC_H);
    return cropTransparentCanvas(canvas, 'The shirt cutout was empty.');
  }

  function drawNeckPrint(context, state, variant) {
    if (resolvedNeckPrint(variant) !== 'white') return;
    context.save();
    context.globalCompositeOperation = 'screen';
    context.drawImage(state.neckPrintImage, 0, 0, DOC_W, DOC_H);
    context.restore();
  }

  function canvasBlob(canvas, type, quality) {
    return new Promise(function(resolve, reject) {
      var finished = false;
      var timer = window.setTimeout(function() {
        if (finished) return;
        finished = true;
        reject(new Error('The preview image took too long to export.'));
      }, 60000);
      try {
        canvas.toBlob(function(blob) {
          if (finished) return;
          finished = true;
          window.clearTimeout(timer);
          if (!blob) {
            reject(new Error('The preview image could not be exported. Reload the page and try again.'));
            return;
          }
          resolve(blob);
        }, type, quality);
      } catch (error) {
        if (finished) return;
        finished = true;
        window.clearTimeout(timer);
        reject(error);
      }
    });
  }

  function generate(state) {
    runGeneration([state], state.root.querySelector('.js-ac-generate')).catch(function() {});
  }

  function generateAll(button) {
    var editors = Array.prototype.slice.call(document.querySelectorAll('[data-ac-production-editor]'));
    var waiting = editors.filter(function(root) { return !root.acStudioState; })[0];
    if (waiting) {
      window.alert(waiting.acStudioError || 'The artwork is still loading. Wait for every preview, then generate.');
      return;
    }
    var designButtons = document.querySelectorAll('.js-ac-generate');
    designButtons.forEach(function(item) { item.disabled = true; });
    runGeneration(editors.map(function(root) { return root.acStudioState; }), button).catch(function() {
      designButtons.forEach(function(item) { item.disabled = false; });
    });
  }

  function runGeneration(states, button) {
    var originalText = button.textContent;
    var total = states.reduce(function(sum, state) { return sum + state.variants.length; }, 0);
    var completed = 0;
    var generatedBatchUrl = null;
    button.disabled = true;
    return states.reduce(function(chain, state) {
      return chain.then(function() {
        syncStateFromArtwork(state);
        return state.variants.reduce(function(colorChain, variant) {
          return colorChain.then(function() {
            button.textContent = 'Generating ' + (completed + 1) + ' of ' + total + '…';
            return generateVariant(state, variant);
          }).then(function(result) {
            completed += 1;
            generatedBatchUrl = result.batch_url || generatedBatchUrl;
          });
        }, Promise.resolve());
      });
    }, Promise.resolve()).then(function() {
      button.textContent = 'Opening generated assets…';
      window.location.href = generatedBatchUrl || window.location.href;
    }).catch(function(error) {
      button.disabled = false;
      button.textContent = originalText;
      window.alert(error.message || 'The packages could not be generated.');
      return Promise.reject(error);
    });
  }

  function generateVariant(state, variant) {
    return loadImage(variant.base_url).then(function(baseImage) {
      return Promise.all([
        canvasBlob(renderPresentation(state, variant, baseImage), 'image/jpeg', 0.95),
        canvasBlob(renderWebsite(state, variant, baseImage), 'image/png'),
        state.sourceArtworkBlob ? Promise.resolve(state.sourceArtworkBlob) : canvasBlob(state.artworkImage, 'image/png'),
      ]);
    }).then(function(files) {
      var form = new FormData();
      form.append('presentation', files[0], 'presentation.jpg');
      form.append('website', files[1], 'website.png');
      form.append('artwork', files[2], 'artwork.png');
      return fetch(variant.generate_url, {
        method: 'POST', credentials: 'same-origin', headers: { 'X-CSRF-Token': csrfToken(), 'Accept': 'application/json' }, body: form,
      });
    }).then(function(response) {
      return response.text().then(function(text) {
        var json = {};
        if (text) {
          try { json = JSON.parse(text); } catch (error) { json = {}; }
        }
        if (!response.ok) throw new Error(json.error || 'The color package could not be saved.');
        return json;
      });
    });
  }

  return { init: init };
})();

document.addEventListener('DOMContentLoaded', AcProductionStudio.init);

export default AcProductionStudio;
